import React from 'react';
import { LoginForm } from '@/components/auth';

export const LoginPage: React.FC = () => {
  return <LoginForm />;
};